module.exports = __webpack_public_path__ + "static/media/plus.7b49bc46.svg";